/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./withFlexibleUIBlockCardStyle.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { N40 } from '@atlaskit/theme/colors';
var flexibleBlockCardStyle = null;
export var withFlexibleUIBlockCardStyle = function withFlexibleUIBlockCardStyle(FlexibleBlockCardView) {
  return function (props) {
    return /*#__PURE__*/React.createElement("div", {
      className: ax(["_1g961mok _1qo3155r"]),
      style: {
        "--_gf55z1": ix("var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-border, ".concat(N40, ")")))
      }
    }, /*#__PURE__*/React.createElement(FlexibleBlockCardView, props));
  };
};